import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=46fd4b0c"
import script from "./EditOrder.vue?vue&type=script&lang=js"
export * from "./EditOrder.vue?vue&type=script&lang=js"
import style0 from "./EditOrder.vue?vue&type=style&index=0&id=46fd4b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports